import type { SVGProps } from 'react';

const SvgViewCarousel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M2 7h4v10H2zm5 12h10V5H7zM18 7h4v10h-4z" />
  </svg>
);
export default SvgViewCarousel;
